import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { ActionResult, DropletInfo } from './types';

const keys = {
  list: ['droplets'] as const,
  detail: (id: string) => ['droplets', id] as const,
};

export function useDroplets() {
  return useQuery({
    queryKey: keys.list,
    queryFn: () => apiFetch<DropletInfo[]>('/droplets'),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

export function useDroplet(id: string | undefined) {
  return useQuery({
    queryKey: keys.detail(id ?? ''),
    queryFn: () => apiFetch<DropletInfo>(`/droplets/${id}`),
    enabled: Boolean(id),
    staleTime: 10_000,
    refetchInterval: 30_000,
  });
}

export function useLinkDroplet() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ tenantId, workspaceId, dropletId }: {
      tenantId: string; workspaceId: string; dropletId: string;
    }) =>
      apiFetch<ActionResult>(`/droplets/link/${tenantId}/${workspaceId}`, {
        method: 'POST',
        body: JSON.stringify({ droplet_id: dropletId }),
      }),
    onSuccess: (_, { tenantId, workspaceId }) => {
      qc.invalidateQueries({ queryKey: keys.list });
      qc.invalidateQueries({ queryKey: ['tenants'] });
      qc.invalidateQueries({ queryKey: ['tenants', tenantId] });
      qc.invalidateQueries({ queryKey: ['tenants', tenantId, 'workspaces', workspaceId] });
    },
  });
}
